import "./ProfilePages.scss";
import { Link } from "react-router-dom";
import ArrowIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
const ProfilePages = () => {
  return (
    <div className="terms-and-conditions">
      <div className="container">
        <h4 className="title">الصفحات التعريفية</h4>
        <div className="actions-container">
          <Link className="action-link" to={"/profile-pages/students"}>
            الصفحات التعريفية ( الطالب )
            <ArrowIcon className="icon" />
          </Link>
          <Link className="action-link" to={"/profile-pages/trainers"}>
            الصفحات التعريفية ( المدرب )
            <ArrowIcon className="icon" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProfilePages;
